import { render, staticRenderFns } from "./BoardHomeComponent.vue?vue&type=template&id=6d3ba16a&scoped=true&"
import script from "./BoardHomeComponent.vue?vue&type=script&lang=js&"
export * from "./BoardHomeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3ba16a",
  null
  
)

export default component.exports